// const $ = require("jquery");

function initNav() {
  var $drops = $(".dropdown--collapse");
  $drops.active = false;

  function logActive() {
    if (_atlas_.debug) {
      console.log("====");
      console.log($drops.active, $drops.activeID);
      console.log("====");
    }
  }
  // events
  $(".js-drop").on(" mouseover", function (e) {
    $drops.active = true;
    // e.preventDefault();
    var drop = $(this).attr("aria-controls");
    $drops.activeID = drop; // cahche this for checks
    // console.log("====");
    // console.log("show ", drop, $drops.active);
    // console.log("====");

    // $drops.collapse("hide");
    $drops.not("#" + $drops.activeID).collapse("hide"); // hide all but active
    // $drops.removeClass("show");
    setTimeout(() => {
      $("#" + drop).collapse("show");
    }, 100); // 200 is glitch
  });

  $drops.mouseenter(function (params) {
    logActive();
    $drops.active = true;
  });

  $drops.mouseleave(function (params) {
    // console.log("====");
    // console.log($drops.not("#" + $drops.activeID));
    // console.log("====");
    $drops.active = false;
    setTimeout(function () {
      if (!$drops.active) {
        $drops.collapse("hide");
      }
    }, 300);
    // $drops.not("#" + $drops.activeID).collapse("hide");
    // $drops.collapse("hide"); // bounces because you hide all
    // allow check for js-drop

    logActive();
  });

  $(".js-drop").on("mouseleave", function () {
    $drops.active = false;
    setTimeout(function () {
      if (!$drops.active) {
        $drops.collapse("hide");
      }
      logActive();
    }, 300);
  });
}

export default initNav;
